import { allProviderSpecialties } from './ProviderUtil';
import {
    GAC_ONLY,
    PLACE,
    ORGANIZATION,
    PROVIDER_TYPE_SINGLE_ESTIMATE_LABELS,
} from '../constants/index';
import formatNumberToCurrency from '../utils/NumberUtil';

export const displayProviderName = (providerInfoForDisplay) => {
    return getNameFromProvider(providerInfoForDisplay);
};

export const getNameFromProvider = (provider) => {
    return provider ? provider?.unTranslatedText : '';
};

export const displayProviderSpecialty = (providerInfoForDisplay) => {
    return getProviderSpecialties(providerInfoForDisplay);
};

export const getProviderSpecialties = (provider) => {
    return allProviderSpecialties(provider?.locAndPractRole)?.length > 0
        ? allProviderSpecialties(provider?.locAndPractRole).join(', ')
        : 'No Specialties Found';
};

export const checkiIfRenderPhysicianAndFacility = (serviceInfo) => {
    return serviceInfo?.facilityChargeInfo ?? false;
};

export const getCardTitle = (serviceInfo, singleClaim) => {
    const splitServiceName = serviceInfo?.name?.split(' - ')[0];

    let providerType = getProviderType(singleClaim);

    if (!providerType) {
        providerType = ifRevenueCodeExists(singleClaim) ? 'FACILITY' : 'PERSON';
    }
    const printedString = `${singleClaim?.id}. ${getChargeTypeLabel(
        providerType
    )} - ${splitServiceName}`;

    return printedString;
};

export const getProviderType = (singleClaim) => {
    return singleClaim?.procedures?.[0]?.provider?.providerType;
};

export const ifRevenueCodeExists = (singleClaim) => {
    return singleClaim?.procedures?.[0]?.procedureCode?.revenueCode ? true : false;
};

export const getChargeTypeLabel = (providerType) => {
    return providerType ? PROVIDER_TYPE_SINGLE_ESTIMATE_LABELS[providerType?.toUpperCase()] : '';
};

export const checkIfClaimIsGACOnly = (singleClaim) => {
    return singleClaim?.procedures?.[0]?.provider?.tierLevel == GAC_ONLY;
};

export const checkIfSecondFacilityClaim = (renderPhysicianAndFacility, claimProviderType) => {
    return (
        renderPhysicianAndFacility &&
        (claimProviderType == PLACE || claimProviderType == ORGANIZATION)
    );
};

export const checkDisplayProviderCard = (hasNoGACPACRatesAvailable) => {
    return !hasNoGACPACRatesAvailable;
};

export const estimatedCostDisplayEstimate = (costShare) => {
    if (costShare?.rate || costShare?.rate == 0) {
        return formatNumberToCurrency(costShare.rate, costShare?.outOfPocket);
    } else {
        return 'Not Available';
    }
};

export const determineCostShareClaimType = (categoryList, coverageType) => {
    return categoryList?.find(
        (category) => category?.categoryName?.toUpperCase() == coverageType?.toUpperCase()
    );
};
